import { atom } from "recoil";

export const menuStateAtom = atom<string | null>({
  key: "nav-bar-menu-option",
  default: null
});
